
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor-ind"  v-model="empresaf" 
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-filial_cor">Filial</label> 
                <multiselect id="selecao-filial-coe-ind"  v-model="value_filial"
                  :options="filiaisf" 
                  :multiple="true"         
                  @close="loadTipos()"
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              <b-col cols="2">
                <label for="select-tpcorretiva-ind">Tipo de corretiva</label> 
                <multiselect  v-model="value_tipo" 
                  :options="tipos"                   
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione o tipo" label="tipo" track-by="tipo" name="tipo"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final"  placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              
              <!-- condicional para exibir o botão planilha-->
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2"  @click="loadkpiDefeitoCausador(),loadkpiAbastecimento(),loadkpiCorretiva(),loadkpiPeriodo(),loadkpiTipoRecolhe(),loadkpiOperador(),loadkpiCarro(),loadkpiLinha()">
                   carregar
                </b-button>                      
              </b-col>

          </b-row>
    </b-form>   

    <div>
      <b-row>

        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
        

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="COMBUSTÍVEL"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.qtd_abastecido), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) != 'NaN' 
                     ? (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.qtd_abastecido), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                     : 0
                  }}  
                  </h2>
                </b-card-text>
              </b-card>
        
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="QUILOMETRAGEM PERCORRIDA"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{  (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.km_rodado), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) != 'NaN'
                  ? (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.km_rodado), 0)).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                  : 0 }}  
                </h2>
                
                
              </b-card-text>
            </b-card>
        
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="CORRETIVAS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ kpiCorretiva.length }}
                </h2>
                
              </b-card-text>
      </b-card>        
      
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="CORRETIVAS MKBF"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                    {{ kpiCorretiva.reduce((count, item) => (item.tipo_oco_rec === 26 || item.tipo_oco_rec === 31 ? count + 1 : count), 0) }}
                </h2>
                
              </b-card-text>
      </b-card>        
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="MKBF  " 
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{
                  (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.km_rodado), 0)) > 0 ?
                  (
                  (kpiAbastecimento.reduce((total, item) => total + parseFloat(item.km_rodado), 0))
                   /                  
                  (kpiCorretiva.reduce((count, item) => (item.tipo_oco_rec === 26 || item.tipo_oco_rec === 31 ? count + 1 : count), 0)) 
                  ).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                  :0
                }}  
              </h2>
              
            </b-card-text>
          </b-card>
      </b-card-group> 

        

      </b-row>
      
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  
          <!-- diário  -->
          <b-col cols="7" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>

          <!-- DEFEITO CAUSADOR  -->
          <b-col cols="5">
            <apexcharts 
            ref="chartdefeitocausador"
            height="400" :options="graficoDefeitoCausador" 
            :series="seriesdefeitocausador"></apexcharts>
          </b-col>



        </b-row>

        

        <b-row>
          <div>


          </div>


          <!-- TIPO RECOLHE  -->
          <b-col cols="4" class="mt-4" id="tiporecolhe">            
            <apexcharts             
            ref="charttipo"
            height="400" 
            :options="graficoTipoCorretiva" 
            :series="seriestipo"
            >
            </apexcharts>
          </b-col>

          
          <!-- acumulado  OPERADOR
           -->
          <b-col cols="2">
            <apexcharts
            ref="chartfuncionario" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesfuncionario"
            ></apexcharts>
          </b-col>

          <!-- acumulado  CARRO -->
          <b-col cols="3">
            <apexcharts 
            ref="chartcarro"
            height="400" :options="graficoCarro" 
            :series="seriescarro"></apexcharts>
          </b-col>

   


          <!-- acumulado  LINHA -->
          <b-col cols="3">
            <apexcharts 
            ref="chartlinha"
            height="400" :options="graficoLinha" 
            :series="serieslinha"></apexcharts>
          </b-col>

        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>-


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false                
              },
    },
  xaxis: {
    categories: [],
    tickPlacement: 'of',
    labels: {
      style: {
        fontSize: '14px',  // Defina o tamanho da fonte dos rótulos do eixo x
        fontWeight: 'bold',  // Opcional: peso da fonte
        colors: '#263238'  // Opcional: cor da fonte
      },
    },
  }, 
  title: {
    text: 'Corretivas diárias',
    align: 'center',
    margin: 10,
    offsetX: 0,  // Ajusta a posição do título no eixo x
    offsetY: -10,  // Ajusta a posição do título no eixo y (negativo para mover para cima)
    floating: false,
    style: {
      fontSize: '22px',  // Tamanho da fonte do título
      fontWeight: 'bold',  // Peso da fonte do título
      color: '#263238'  // Cor da fonte do título
    },
  },
  
    
  },



/*  DEFEITO CAUSADOR */
/* Operador    */
  graficoDefeitoCausador: {
    chart: {
              id: 'bar-defeitocausador',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 defeitos causadores',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  
  /* Tipo de corretiva */
  graficoTipoCorretiva: {
    chart: {
              id: 'bar-tipo',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {
//         colors: generateRandomColors() // Gere cores dinamicamente






        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Tipo de corretivas',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  
/* Operador    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por operadores',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


  
/* Operador    */
  graficoCarro: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por carros',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  


  /* Linha */
  graficoLinha: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {        
        horizontal: true,
       // isFunnel: true,        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 20 por linhas',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  empresaf:'', 
  empresasf:[],   // [] lista       
  filialf:'', 
  filiaisf: [],   // [] lista   
  tipo:'',
  tipos:[],


/* objetos */
  kpiAbastecimento:[],
  kpiCorretiva:[],  

  kpidias:[],  
  seriesdia:[],

  kpimkbf:[],
  kpiqtds:[],
  kpitipos:[],  
  kpifuncionario:[] ,
  kpilinha:[],
  kpicarro:[],
  seriestipo:[],
  seriesfuncionario:[],
  serieslinha:[],
  seriescarro:[],


  kpidefeitocausador:[],
  seriesdefeitocausador:[],


  dt_inicial: '',
  dt_final: '',  

  sinistros:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfilial:[],  
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     
  value_tipo:[],     

        }        
    },

    

    methods: {    
      
      loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { filial_id: filial.filial_id, filial: filial.filial }        
            })
          })
      },

      loadTipos() {
                    let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/manutencao/corretiva/ticocorretiva`  
          axios.post(url,corpo).then(res => {
            this.tipos = res.data.map(tp => {              
              return { ... tp, value:  tp.id_tipo_recolhida, tipo: tp.descritivo }              
            })            
          })          
      },


  async loadkpiAbastecimento() {
            let corpo = {    
              /*
                  "empresa_id": `${this.empresaf.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                                                                                  
                  */
                "empresa_id": `${[this.user.id_empresa]}`,                            
                "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
                //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
                "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                  "dt_inicial": `${this.dt_inicial}`,                                            
                  "dt_final": `${this.dt_final}`,                                            
            };
            const url = `${baseApiUrl}/jb/indicadores/abastecimento`
            axios.post(url,corpo)
              .then(res => {
                this.kpiAbastecimento = res.data                              
              })
              .catch(showError)
        },


      async loadkpiCorretiva() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'RESUMO'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
              this.kpiCorretiva= res.data                              
            })
            .catch(showError)
      },
      

      async loadkpiPeriodo() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'PERIODO'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
              this.kpidias= res.data     
              this.updateChartDataDia();         
            })
            .catch(showError)
      },

      async updateChartDataDia() {
      this.seriesdia = [{
        name: 'Qtd corretivas',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        categories: this.kpidias.map(d => moment(String(d.dt_abertura)).format('DD/MM') )   // 
      }  });       
    },


      async loadkpiDefeitoCausador() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'DEFEITOCAUSADOR'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
            this.kpidefeitocausador = res.data 
            this.updateChartDataDefeitoCausador();           
            })
            .catch(showError)
  },

      async updateChartDataDefeitoCausador() {
      this.seriesdefeitocausador = [{
        name: 'Qtd defeitos',
        data: this.kpidefeitocausador.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdefeitocausador.updateOptions({ xaxis:{
        categories: this.kpidefeitocausador.map(r => r.kpi_defeitocausador)
      }  });       
    },








    async loadkpiTipoRecolhe() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'TIPORECOLHE'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
              this.kpitipos= res.data     
              this.updateChartDataTipo();         
            })
            .catch(showError)
      },

      async updateChartDataTipo() {
      this.seriestipo = [{
        name: 'Qtd corretivas',
        data: this.kpitipos.map(item => parseInt(item.qtd)),
        }];
      this.$refs.charttipo.updateOptions({ xaxis:{
        categories: this.kpitipos.map(d => d.tiporecolhe)
      }  });       
    },


async loadkpiOperador() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'OPERADOR'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
              this.kpifuncionario= res.data     
              this.updateChartDataFuncionario();         
            })
            .catch(showError)
  },

      async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd sinistros',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.solicitante_re)
      }  });       
    },





  async loadkpiCarro() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'CARRO'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
            this.kpicarro = res.data 
            this.updateChartDataCarro();           
            })
            .catch(showError)
  },

      async updateChartDataCarro() {
      this.seriescarro = [{
        name: 'Qtd sinistros',
        data: this.kpicarro.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartcarro.updateOptions({ xaxis:{
        categories: this.kpicarro.map(r => r.carro)
      }  });       
    },






  async loadkpiLinha() {
          let corpo = {                
              "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,                                            
               //"status_id": `${[this.value_status.map( s => s.id_status)]}`,        
               "id_tipo_recolhida":`${[this.value_tipo.map(t => t.id_tipo_recolhida)]}`,
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,
                "tipo":'LINHA'                                            
          };
          const url = `${baseApiUrl}/jb/indicadores/corretiva`
          axios.post(url,corpo)
            .then(res => {
            this.kpilinha = res.data 
            this.updateChartDataLinha();        
            })
            .catch(showError)
      },


    async updateChartDataLinha() {
      this.serieslinha = [{
        name: 'Qtd sinistros',
        data: this.kpilinha.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartlinha.updateOptions({ xaxis:{
        categories: this.kpilinha.map(r => r.linha)
      }  });       
    },












    },




    mounted(){      
      this.loadEmpresas()
      this.loadFiliais()
       
    },

    
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>